export var newYear2025SnakeType;
(function (newYear2025SnakeType) {
    newYear2025SnakeType[newYear2025SnakeType["FORTUNE"] = 1] = "FORTUNE";
    newYear2025SnakeType[newYear2025SnakeType["REUNION"] = 2] = "REUNION";
    newYear2025SnakeType[newYear2025SnakeType["BLESSING"] = 3] = "BLESSING";
    newYear2025SnakeType[newYear2025SnakeType["ROMANCE"] = 4] = "ROMANCE";
    newYear2025SnakeType[newYear2025SnakeType["RAISE"] = 5] = "RAISE";
    newYear2025SnakeType[newYear2025SnakeType["HEALTHY"] = 6] = "HEALTHY";
    newYear2025SnakeType[newYear2025SnakeType["SAFE"] = 7] = "SAFE";
    newYear2025SnakeType[newYear2025SnakeType["LUCKY"] = 8] = "LUCKY";
    newYear2025SnakeType[newYear2025SnakeType["GOLDEN"] = 9] = "GOLDEN";
})(newYear2025SnakeType || (newYear2025SnakeType = {}));
export var newYear2025CategoryType;
(function (newYear2025CategoryType) {
    newYear2025CategoryType[newYear2025CategoryType["LIVE"] = 1] = "LIVE";
    newYear2025CategoryType[newYear2025CategoryType["VIDEO_AND_CARD"] = 2] = "VIDEO_AND_CARD";
    newYear2025CategoryType[newYear2025CategoryType["SPORT_AND_ESPORT"] = 3] = "SPORT_AND_ESPORT";
})(newYear2025CategoryType || (newYear2025CategoryType = {}));
export var newYear2025BonusType;
(function (newYear2025BonusType) {
    newYear2025BonusType["BONUS_0"] = "0";
    newYear2025BonusType["BONUS_8"] = "8";
    newYear2025BonusType["BONUS_18"] = "18";
    newYear2025BonusType["BONUS_28"] = "28";
    newYear2025BonusType["BONUS_58"] = "58";
    newYear2025BonusType["BONUS_88"] = "88";
})(newYear2025BonusType || (newYear2025BonusType = {}));
//# sourceMappingURL=NewYear2025.js.map